import { useSyncExternalStore } from "react";
import { onlineManager } from "@tanstack/react-query";

/**
 * TanStack Query가 쿼리/뮤테이션 실행 여부를 판단할 때 쓰는 것과 같은
 * onlineManager를 구독한다. navigator.onLine을 별도로 구독하지 않는 이유는,
 * 이 값과 쿼리의 paused 상태가 서로 다른 소스에서 어긋나는 걸 막기 위해서다.
 */
export function useOnlineStatus(): boolean {
  return useSyncExternalStore(
    (callback) => onlineManager.subscribe(callback),
    () => onlineManager.isOnline(),
    () => true,
  );
}
